import { Button } from 'antd';

import { useRedirect, useUserRole } from 'hooks';

import { Links } from 'links';

export const NewOfferButton = () => {
  const handleRedirect = useRedirect();

  const { isAdmin } = useUserRole();

  if (!isAdmin) {
    return null;
  }

  return (
    <Button
      type='primary'
      onClick={handleRedirect(`${Links.Offers}/new`)}
    >
      New Offer
    </Button>
  );
};
